export const OPENDAYS_NON_ADVERTISER_DESCRIPTION =
  "There are currently no upcoming open days at this uni. In the meantime, take a look at these unis with open days coming up soon.";

export const getAdvertiserDescription = (totalOpenDays: number, univName: string) =>
  `Explore ${totalOpenDays} upcoming open ${totalOpenDays === 1 ? "day" : "days"} at ${univName}. Use our filters to sort by subject, study level, and date to find the best events for your schedule.`;

export const OVERVIEW_TEXT =
  "When you visit the uni for an open day, expect plenty of opportunities to look around the campus, talk to lecturers or other students, ask any questions you've got, and more. We also recommend checking out the surrounding area to see if it's a good fit for you.";

export const OVERVIEW_TITLE = "Overview";

export const FEATURED_TOURS_TITLE = "Featured tours";

export const LOCATION_TITLE = "How to get to your open day?";

export const GALLERY_TITLE = "Gallery";

export const NO_ADDRESS_TEXT = "No address available";
